import { useState, useEffect } from 'react';

/**
 * Hook para debounce de valores
 * Útil para limitar a frequência de chamadas de API durante a digitação
 * 
 * @param value O valor a ser debounced
 * @param delay O tempo de espera em milissegundos
 * @returns O valor após o debounce
 */
export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Configurar o timer para atualizar o valor após o delay
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Limpar o timer se o valor mudar antes do delay
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
} 